var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"name":_vm.transition}},[(_vm.visible)?_c('div',{staticClass:"overlay",style:({'z-index': _vm.zIndex})}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }